<template>
  <a-drawer
    title="模板配置"
    :maskClosable="true"
    :width="800"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="templateConfig"
    style="overflow: auto; padding-bottom: 53px"
  >
    <div>
      <a-form
        layout="horizontal"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-item label="标题">
          <a-input v-model="templateConfigData.title" disabled="disabled" />
        </a-form-item>
        <a-form-item label="链接">
          <a-input v-model="templateConfigData.url" />
        </a-form-item>
        <a-form-item label="小程序appid">
          <a-input v-model="templateConfigData.miniprogram.appid" />
        </a-form-item>
        <a-form-item label="小程序路径">
          <a-input v-model="templateConfigData.miniprogram.pagePath" />
        </a-form-item>
        <a-form-item label="模版名称">
          <a-input v-model="templateConfigData.name" />
        </a-form-item>
        <a-form-item label="模板状态">
          <a-switch
            checked-children="启用"
            un-checked-children="未启用"
            v-model="templateConfigData.openFlag"
          />
        </a-form-item>
        <div style="border: 1px dashed #aaa">
          <a-form-item label="模板内容">
            <p>消息填充数据，请对照模板内容填写</p>
            <a-textarea
              v-model="templateConfigData.content"
              disabled="disabled"
              :auto-size="{ minRows: 3, maxRows: 5 }"
            />
          </a-form-item>
          <a-form-item
            v-for="item in templateConfigData.data"
            :label="item.name"
            :key="item.name"
          >
            <a-row :gutter="24">
              <a-col :span="10">
                <a-input v-model="item.value" placeholder="" />
              </a-col>
              <a-col :span="14">
                颜色<a-input
                  v-model="item.color"
                  style="width: auto; margin-left: 20px"
                />
              </a-col>
            </a-row>
          </a-form-item>
        </div>
      </a-form>
    </div>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="templateConfigOkay" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>
<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import { postTag } from '../../../../api/manage';

export default {
  name: 'EventCommandModal',
  components: {
    JDate
  },
  data() {
    return {
      status: false,
      form: this.$form.createForm(this),
      title: '操作',
      appId: '',
      width: 800,
      templateConfig: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_WECHAT + '/eventCommand/add',
        edit: process.env.VUE_APP_CMS_WECHAT + '/eventCommand/edit'
      },
      templateConfigData: { miniprogram: {}, data: [] }
    };
  },
  created() {},
  methods: {
    templateOpen(row) {
      this.templateConfigData = { ...row };
      if (this.templateConfigData.openFlag == '1') {
        this.templateConfigData.openFlag = true;
      } else {
        this.templateConfigData.openFlag = false;
      }
      if (!this.templateConfigData.miniprogram) {
        this.templateConfigData.miniprogram = { appid: '', pagePath: '' };
      } else {
        this.templateConfigData.miniprogram = JSON.parse(
          this.templateConfigData.miniprogram
        );
      }
      if (
        !this.templateConfigData.data ||
        this.templateConfigData.data.length == 0
      ) {
        this.templateConfigData.data = [];
        let keysArray =
          this.templateConfigData.content.match(/\{\{(\w*)\.DATA\}\}/g) || [];
        keysArray.map(item => {
          let name = item.replace('{{', '').replace('.DATA}}', '');
          this.templateConfigData.data.push({
            name: name,
            value: '',
            color: '#000000'
          });
        });
      } else {
        this.templateConfigData.data = JSON.parse(this.templateConfigData.data);
      }
      this.templateConfig = true;
    },
    validForm(type) {
      if (!this.templateConfigData.name) {
        this.$message.warn('请输入模版名称');
        return false;
      }
      if (this.templateConfigData.data.length > 0) {
        for (let index in this.templateConfigData.data) {
          let item = this.templateConfigData.data[index];
          /*if (item.value == undefined || item.value == null || item.value == '' ) {
              this.$message.warn('请输入' + item.name)
              return false
            }*/
          if (!item.color) {
            this.$message.warn('请输入' + item.name + '的颜色');
            return false;
          }
        }
      }
      if (this.templateConfigData.sendRule === 1) {
        if (type == 2 && !this.templateConfigData.openId) {
          this.$message.warn('请选择推送用户');
          return false;
        }
      }
      return true;
    },
    templateConfigOkay() {
      if (!this.validForm(1)) {
        return false;
      }
      let data = { ...this.templateConfigData };
      if (data.openFlag) {
        data.openFlag = '1';
      } else {
        data.openFlag = '0';
      }
      data.data = JSON.stringify(data.data);
      data.miniprogram = JSON.stringify(data.miniprogram);
      postTag(process.env.VUE_APP_CMS_WECHAT + '/msgTemplate/edit', data).then(
        res => {
          if (res.success) {
            this.$message.success('修改成功');
            this.$emit('ok');
            this.templateConfig = false;
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    handleCancel() {
      this.close();
    },

    close() {
      this.$emit('close');
      this.templateConfig = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let method = '';
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          if (this.appId) {
            formData.appId = this.appId;
          }
          formData.createTime = '';
          formData.createBy = '';
          formData.delFlag = '';
          if (formData.status) {
            formData.status = '1';
          } else {
            formData.status = '0';
          }
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'name',
          'eventCommand',
          'handleType',
          'appId',
          'handleContent'
        )
      );
    },
    handleType(val) {
      this.model.handleContent = '';
      if (val === 'text') {
        this.handleContentPlaceholder = '一段文本，支持a标签';
      } else if (val === 'image') {
        this.handleContentPlaceholder = '素材ID';
        this.model.handleContent = '{"MediaId": ""}';
      } else if (val === 'voice') {
        this.handleContentPlaceholder = '素材ID';
        this.model.handleContent = '{"MediaId": ""}';
      } else if (val === 'video') {
        this.handleContentPlaceholder = '素材ID';
        this.model.handleContent =
          '{"MediaId": "", \n"Title": "", \n"Description": ""}';
      } else if (val === 'music') {
        this.handleContentPlaceholder = '素材ID';
        this.model.handleContent =
          '{"Title": "", \n"Description": "", \n"MusicUrl": "", \n"HQMusicUrl": "", \n"ThumbMediaId": ""}';
      } else if (val === 'news') {
        this.model.handleContent = '{"ArticleId": "", \n"Url": ""}';
      } else if (val === 'other') {
        this.handleContentPlaceholder = '执行Bean的名字';
      }
      this.form.setFieldsValue(pick(this.model, 'handleContent'));
    }
  }
};
</script>
